import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import DefectDetail from "./defectDetail";
import TableList from "./Defects";
import WorkOrder from "./workorder";
import VehilcleList from "./customerVehicles";
class DefectRoute extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/defects" component={VehilcleList} />
        <Route exact path="/defects/:vid" component={TableList} />
        <Route exact path="/defects/detail/:dId" component={DefectDetail} />
        <Route exact path="/defects/work/order/:dId" component={WorkOrder} />
      </Switch>
    );
  }
}

export default DefectRoute;



// WEBPACK FOOTER //
// ./src/views/Defects/defectRoute.js